export default "__VITE_ASSET__Cr94s9WT__"